import { render, staticRenderFns } from "./FinnishFlag.vue?vue&type=template&id=65a53bcc&"
import script from "./FinnishFlag.vue?vue&type=script&lang=js&"
export * from "./FinnishFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports